import script from "./RoomInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomInfo.vue?vue&type=script&setup=true&lang=js"

import "./RoomInfo.vue?vue&type=style&index=0&id=348457f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-348457f2"]])

export default __exports__